module.exports = __webpack_public_path__ + "img/CSL-Logo-Small-300x225.650b9d7d.png";